import {
  Box,
  MenuItem,
  Pagination,
  TextField,
  Typography,
} from "@mui/material";
export default function TablePagination({
  count,
  page,
  pageSize,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = [5, 10, 20, 50, 100],
}) {
  const sizes = [...new Set([...pageSizeOptions, pageSize])].sort(
    (a, b) => a - b
  );
  return (
    <Box
      sx={{
        p: 2,
        display: "flex",
        gap: 2,
        alignItems: "center",
        flexWrap: "wrap",
        borderTop: "1px solid",
        borderColor: "divider",
      }}
    >
      <Typography variant="body2" color="text.secondary" aria-live="polite">
        Showing {count ? page * pageSize + 1 : 0}–
        {Math.min((page + 1) * pageSize, count)} of {count}
      </Typography>
      <TextField
        select
        size="small"
        label="Rows per page"
        value={pageSize}
        onChange={(e) => onPageSizeChange(Number(e.target.value))}
        sx={{ minWidth: 120 }}
      >
        {sizes.map((size) => (
          <MenuItem key={size} value={size}>
            {size}
          </MenuItem>
        ))}
      </TextField>
      <Pagination
        count={Math.max(1, Math.ceil(count / pageSize))}
        page={page + 1}
        onChange={(_, next) => onPageChange(next - 1)}
        showFirstButton
        showLastButton
        size="small"
        sx={{ ml: { md: "auto" } }}
      />
    </Box>
  );
}
